/**
 * Shared status palette for the Phase-A triage UI.
 *
 * Pulled out of `PassVectorTriage.jsx` during the Phase A · Step 5
 * refactor so the visual contract is a single source of truth across
 * the row, the bulk bar, the harvest strip, and future tiles.
 *
 * Each status maps to:
 *   • `label` — human-readable noun
 *   • `ring`  — Tailwind ring class (border-emphasis on the row)
 *   • `badge` — Tailwind background+text+border for the inline pill
 *   • `dot`   — Tailwind background for the leading marker dot
 *
 * Adding a new status: keep the 4-key shape so every consumer stays
 * exhaustive without runtime checks.
 */
export const STATUS_STYLES = {
  unverified: {
    label: "Unverified",
    ring: "ring-amber-400/40",
    badge: "bg-amber-400/15 text-amber-300 border-amber-400/40",
    dot: "bg-amber-400",
  },
  verified: {
    label: "Verified",
    ring: "ring-emerald-400/40",
    badge: "bg-emerald-400/15 text-emerald-300 border-emerald-400/40",
    dot: "bg-emerald-400",
  },
  corrected: {
    label: "Corrected",
    ring: "ring-amber-300/40",
    badge: "bg-amber-300/15 text-amber-200 border-amber-300/40",
    dot: "bg-amber-300",
  },
  rejected: {
    label: "Rejected",
    ring: "ring-rose-400/40",
    badge: "bg-rose-400/15 text-rose-300 border-rose-400/40",
    dot: "bg-rose-400",
  },
};
